/*
 * Copyright (c) 2025 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import * as constants from './utils/constants.ts';
import { ENVIRONMENTS, getValueByEnv } from './utils/runtimeEnv';

const getAzureRedirectUrl = () => {
  return getValueByEnv({
    [ENVIRONMENTS.LOCAL]: [
      constants.LOCALHOST_URL,
      constants.CAPS_AUTHORITY_DEV,
      constants.CAPS_INSTANCE_DEV,
      constants.CAPS_APPLICATION_ID_DEV,
    ],
    [ENVIRONMENTS.DEV]: [
      constants.DEV_URL,
      constants.CAPS_AUTHORITY_DEV,
      constants.CAPS_INSTANCE_DEV,
      constants.CAPS_APPLICATION_ID_DEV,
    ],
    [ENVIRONMENTS.TEST]: [
      constants.TEST_URL,
      constants.CAPS_AUTHORITY_DEV,
      constants.CAPS_INSTANCE_DEV,
      constants.CAPS_APPLICATION_ID_DEV,
    ],
    [ENVIRONMENTS.PROD]: [
      constants.PROD_URL,
      constants.CAPS_AUTHORITY_PROD,
      constants.CAPS_INSTANCE_PROD,
      constants.CAPS_APPLICATION_ID_PROD,
    ],
  });
};

const [reactRedirectUri, authority, knownAuthorities, clientId] = getAzureRedirectUrl();
export const msalConfigCaps = {
  auth: {
    // authority: signInAuthority,
    authority: authority,
    clientId: clientId,
    redirectUri: reactRedirectUri,
    postLogoutRedirectUri: '/',
    knownAuthorities: [knownAuthorities],
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    allowRedirectInIframe: true,
  },
  response_types: ['code'],
};

export const loginRequestCaps = {
  scopes: ['openid', 'profile'],
  extraQueryParameters: {
    brand: 'GM',
    channel: 'lightreg',
    // requiredMissingInfo: true,
    ui_locales: 'en-US',
  },
};